import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { DrillKind } from "./Drill";

// Короткое название задачи — в итоге серии и в каталоге (docs/drills.md).
export const KIND_TITLES: Record<DrillKind, MessageDescriptor> = {
  buy_now: msg({ id: "drills.kind.buy_now", message: "What will you buy now?" }),
  build_order: msg({ id: "drills.kind.build_order", message: "Put the build together" }),
  buy_minute: msg({ id: "drills.kind.buy_minute", message: "By what minute?" }),
  odd_item: msg({ id: "drills.kind.odd_item", message: "Odd one out" }),
  purchase_mistake: msg({ id: "drills.kind.purchase_mistake", message: "Spot the wrong purchase" }),
  anti_heal: msg({ id: "drills.kind.anti_heal", message: "Anti-heal" }),
  defense_item: msg({ id: "drills.kind.defense_item", message: "What will you buy for defense?" }),
  counter_pairs: msg({ id: "drills.kind.counter_pairs", message: "Enemy → answer" }),
  killer_counters: msg({ id: "drills.kind.killer_counters", message: "What saves you from him?" }),
  finish_him: msg({ id: "drills.kind.finish_him", message: "Finish them" }),
  first_buff: msg({ id: "drills.kind.first_buff", message: "First buff" }),
};
